// يحدد الشعار الكامل المناسب حسب الوضع الليلي/النهاري المفعّل حالياً
// عند غياب أحد الشعارين يُستخدم الآخر كبديل مؤقت، وإن غابا كلاهما يُستخدم الشعار القديم الموحّد (توافقية)
export const resolveLogoFullId = (platformSettings, theme) => {
  if (!platformSettings) return null;
  const dark = platformSettings.platform_logo_full_dark;
  const light = platformSettings.platform_logo_full_light;
  const legacy = platformSettings.platform_logo_full;
  if (theme === 'light') return light || dark || legacy || null;
  return dark || light || legacy || null;
};

export default resolveLogoFullId;
